import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "assets/css/custom.css";

import AdminLayout from "layouts/Admin.js";
import CustomerLayout from "layouts/Customer.js";
import PaymentLayout from "layouts/Payment.js";
import AuthLayout from "layouts/Auth.js";
import LoanAgreement from "views/Agreement/LoanAgreement.jsx";
import RuleEngineDetails from "views/Credit/RuleEngineDetails";
import Webhook from "views/Credit/webhook";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/Agreement/LoanAgreement" element={<LoanAgreement />} />
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/customer/*" element={<CustomerLayout />} />
      <Route path="/payment/*" element={<PaymentLayout />} />
      <Route path="/rule/*" element={<RuleEngineDetails />} />
      <Route path="/webhook/*" element={<Webhook />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="*" element={<Navigate to="/admin/lead-list" replace />} />
    </Routes>
    <ToastContainer />
  </BrowserRouter>
);
  